import React from 'react';
import Overlay from './Overlay';

interface MediaLightboxProps {
  src: string;
  kind: 'image' | 'video';
  onClose: () => void;
}

const MediaLightbox: React.FC<MediaLightboxProps> = ({ src, kind, onClose }) => {
  return (
    <Overlay onClose={onClose}>
      {kind === 'video' ? (
        <video
          src={src}
          controls
          playsInline
          muted
          preload="metadata"
          className="max-w-full max-h-[85vh] rounded-lg shadow-lg"
        />
      ) : (
        <img src={src} alt="" className="max-w-full max-h-[85vh] rounded-lg shadow-lg object-contain" loading="lazy" />
      )}
    </Overlay>
  );
};

export default MediaLightbox;
